import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import { Button } from './ui/Button';
import { BellIcon } from './icons';

export function TopBar() {
  const location = useLocation();
  const {
    user,
    school,
    availableSchools,
    activeSchoolId,
    setActiveSchool,
    favoriteSchoolIds,
    toggleFavoriteSchool,
    logout,
  } = useAuthStore((state) => ({
    user: state.user,
    school: state.school,
    availableSchools: state.availableSchools,
    activeSchoolId: state.activeSchoolId,
    setActiveSchool: state.setActiveSchool,
    favoriteSchoolIds: state.favoriteSchoolIds,
    toggleFavoriteSchool: state.toggleFavoriteSchool,
    logout: state.logout,
  }));

  const showSchoolSelector =
    (availableSchools?.length ?? 0) > 1 ||
    (!user?.schoolId && (availableSchools?.length ?? 0) > 0);

  const isFavorite =
    !!activeSchoolId && favoriteSchoolIds.includes(activeSchoolId);

  const breadcrumbMap: Record<string, string> = {
    '/today': 'Accueil',
    '/messages': 'Messages',
    '/network': 'Agences',
    '/statistics': 'Statistiques',
    '/workspace/notes': 'Espace Équipe · Notes',
    '/workspace/meetings': 'Espace Équipe · Réunions',
    '/workspace/boards': 'Espace Équipe · Tableaux',
    '/workspace/tasks': 'Tâches',
    '/workspace/sequences': 'Séquences d’e-mails',
    '/boutique-permio': 'Boutique Permio',
    '/candidates': 'Candidats',
    '/planning': 'Planning',
    '/bookings': 'Réservations',
    '/slots': 'Calendrier',
    '/realtime': 'Temps réel',
    '/exams': 'Examens',
    '/audit': 'Journal',
    '/windows': 'Seuil formateur',
    '/notifications': 'Réglages / Communication',
    '/security': 'Sécurité',
    '/password': 'Mon mot de passe',
    '/settings': 'Paramètres',
    '/profile': 'Mon compte',
    '/account-settings': 'Mon compte',
    '/help': 'Aide',
    '/guide': 'Guide d’utilisation',
    '/subscriptions': 'Abonnements',
    '/requests': 'Réservation d’examen',
    '/requests/new': 'Nouvelle demande',
    '/fleet': 'Véhicules',
    '/lessons': 'Planning',
    '/instructors': 'Formateurs',
    '/etps': 'Seuil formateur',
    '/billing': 'Facturation',
    '/orders': 'Gestion / Commandes',
    '/quotes': 'Gestion / Facturation',
      '/invoices': 'Gestion / Facturation',
    '/contracts': 'Documents / Contrats',
    '/livret': 'Livret numérique',
    '/checkout': 'Paiement',
    '/catalog': 'Boutique',
  };

  const currentLabel =
    breadcrumbMap[location.pathname] ??
    breadcrumbMap[`/${location.pathname.split('/')[1]}`] ??
    "Vue d'ensemble";

  return (
    <header className="topbar">
      <div className="topbar__left">
        <div className="topbar__breadcrumbs">
          <span>Accueil</span>
          <span className="topbar__chevron">/</span>
          <span className="topbar__breadcrumb-current">
            {currentLabel}
          </span>
        </div>
        <h1 className="topbar__title">
          {school?.name ?? "Vue d'ensemble"}
        </h1>
        <p className="topbar__subtitle">
          Tableau de bord de votre activite.
        </p>
        <div className="topbar__context">
          {showSchoolSelector ? (
            <div className="topbar__selection">
              <label>
                <span>Auto-ecole</span>
                <select
                  value={activeSchoolId ?? ''}
                  onChange={(event) => setActiveSchool(event.target.value)}
                >
                  {availableSchools.map((option) => (
                    <option key={option.id} value={option.id}>
                      {favoriteSchoolIds.includes(option.id) ? '* ' : ''}
                      {option.name}
                    </option>
                  ))}
                </select>
              </label>
              {activeSchoolId ? (
                <button
                  type="button"
                  className={`topbar__favorite ${
                    isFavorite ? 'is-active' : ''
                  }`}
                  onClick={() => toggleFavoriteSchool(activeSchoolId)}
                >
                  {isFavorite ? 'Favori' : 'Ajouter aux favoris'}
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <div className="topbar__right">
        <button type="button" className="topbar__icon-btn">
          <BellIcon />
        </button>
        <div className="topbar__user">
          <div className="topbar__avatar">
            {user?.firstName?.[0]}
            {user?.lastName?.[0]}
          </div>
          <div className="topbar__user-infos">
            <span className="topbar__user-name">
              {user ? `${user.firstName} ${user.lastName}` : 'Utilisateur'}
            </span>
            <span className="topbar__user-role">
              {user?.role ?? 'Gestionnaire'}
            </span>
          </div>
        </div>
        <Button variant="ghost" onClick={logout}>
          Se deconnecter
        </Button>
      </div>
    </header>
  );
}
